import React from "react";
import { Form } from "antd";
import EditableTableContext from "./EditableTableContext";

interface Props {
  index: number;
}
const EditableRow: React.FC<Props> = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false} initialValues={{}}>
      <EditableTableContext.Provider value={form}>
        <tr {...props} />
      </EditableTableContext.Provider>
    </Form>
  );
};
export default EditableRow;
